import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  withStyles,
  Card,
  CardContent,
  CardActions,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import StepActions from "./stepActions";
import RecordInfo from "./recordInfo";
import styles from "./styles";
import ClientTypeSelector from "./clientTypeSelector";

const ReviewRecordStep = (props) => {
  const {
    entity,
    entityAssocaition,
    request,
    listOptions,
    reload,
    canSkip,
    onCancel,
    onNext,
    onBack,
  } = props;
  const { t } = useTranslation();

  const [clientType, setClientType] = useState(null);
  const [clientTypeError, setClientTypeError] = useState("");

  const [attributeChanges, setAttributeChanges] = useState(null);

  useEffect(() => {
    const { records = [] } = request;
    const r = records.find((r) => r.entity.id === entity.id);
    if (r) {
      setClientType(r.clientType);
    }
  }, [request]);

  const handleClientTypeChange = (ct) => {
    setClientTypeError("");
    setClientType(ct);
  };

  const onAttributeChange = (changes) => {
    setAttributeChanges(changes);
  };

  const onEntitySave = async () => {
    reload(entity.id);
    setAttributeChanges(null);
  };

  const handleNext = (event) => {
    if (!clientType) {
      setClientTypeError(t("messages.record.documentRequest.clientTypeError"));
      return;
    }
    onNext(true, { entity, clientType, entityAssocaition });
  };

  const handleCancel = (event) => {
    onCancel();
  };

  const handleBack = (event) => {
    onBack();
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography>
              {t("labels.record.documentRequest.steps.recordReviewStep.header")}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <RecordInfo
              entity={entity}
              showAddress={true}
              listOptions={listOptions}
              onAttributeChange={onAttributeChange}
              onEntitySave={onEntitySave}
            />
          </Grid>
          <Grid item xs={6}>
            <ClientTypeSelector
              request={request}
              entity={entity}
              clientTypeError={clientTypeError}
              onChange={handleClientTypeChange}
            />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions disableSpacing>
        <StepActions
          canSkip={canSkip}
          disableNext={attributeChanges !== null}
          onCancel={handleCancel}
          onNext={handleNext}
          onBack={handleBack}
        />
      </CardActions>
    </Card>
  );
};

export default withStyles(styles, { withTheme: true })(ReviewRecordStep);
